import React, { useEffect, useState } from 'react';
//Estilo Primario
import '../../../../assets/dist/stilo.css';
// import { NavItem, Nav } from 'react-bootstrap'
import parse from 'html-react-parser';
//Logos
// import d1 from '../../../../assets/dist/svg/main.svg';
// import d2 from '../../../../assets/dist/svg/main.svg';
// import Footer from '../../../util/Footer';
import ErrorOutlineRounded from '@material-ui/icons/ErrorOutlineRounded';
import NewHeaderInicio from '../../../util/NewHeaderInicio';
import { CircularProgress } from '@material-ui/core';
import IViewPostulaciones from '../../../view-interfaces/IViewPostulaciones';
// import IViewDeudaFinanciera from '../../../view-interfaces/IViewDeudaFinanciera';
//import { ObtienePostulacionesLogic, ObtieneDeudaBibliotecaLogic, ObtieneDeudaFinancieraLogic, ObtieneDocumentoLEMLogic, ObtienePostulacionesPostExtLogic } from '../../../view-model/Inicio/PostulacionesEstudiante.logic';
import { ObtienePostulacionesPostExtLogic } from '../../../view-model/Inicio/PostulacionesEstudiante.logic';
import {
    ObtieneDatosPersonalesLogic,
    GrabarDatosPersonalesLogic,
    ObtieneDatosTipoPersonaPorPostulacionLogic,
} from '../../../view-model/DatosPersonales/DatosPersonales.logic';
import { useHistory, useLocation } from 'react-router-dom';
import { InsertPrimeraEtapaProcesoLogic } from '../../../view-model/EtapasProceso/EtapasProceso.logic';
// import { FormaPago } from '../../PortalPostulante/SeleccionFormaPago/FormaPago';
// import IViewRepresentanteFinanciero from '../../../view-interfaces/IViewPersona';
/* import ScriptTag from 'react-script-tag'; */
import queryString from 'query-string';
import { animateScroll as scroll } from 'react-scroll';
// import { Postulaciones } from '../../../../application/entity/Postulaciones';
// import { ResponsableFinanciero } from '../../PortalPostulante/DatosPersonales/ResponsableFinanciero';
// import { ObtieneDatosPostulanteLogic } from '../../../view-model/Inicio/InicioEstudiante.logic';
import { ObtieneTieneFirmaContratoLogic } from '../../../view-model/Contrato/Contrato.logic';
import IViewTipoPersona from '../../../view-interfaces/IViewTipoPersona';
import { Alumno } from '../../PortalPostulante/DatosPersonales/Alumno';
import MensajeToken from '../../../../Components/MensajeToken/MensajeToken';
import { ObtenerTokenPostDecLogic } from '../../../view-model/Inicio/InicioEstudiante.logic';

const InicioPostExt: React.FC = () => {
    const history = useHistory();
    const location = useLocation();
    const [urlBad, setUrlBad] = useState(false);
    const [rut, setRut] = useState(0);
    const [pasaporte, setPasaporte] = useState('');
    const [codComercio, setCodComercio] = useState('');
    // const [codPlani, setCodPlani] = useState('');
    const [validando1, setValidando1] = useState(true);
    const [validando2, setValidando2] = useState(true);
    const [validando3, setValidando3] = useState(true);
    // const [validando4, setValidando4] = useState(true);
    const [formaPago, setFormaPago] = useState([]);
    const [textMenuResponsive, setTextMenuResponsive] = useState('');
    const [idProceso, setIdProceso] = useState(0);
    const [menu, setMenu] = useState('3');
    const [nombreAlumno, setNombreAlumno] = useState('');
    const [idPeriodo, setIdPeriodo] = useState(0);
    const [openModalToken, setOpenModalToken] = useState({ open: false, mnsj: "" })
    const lista: IViewPostulaciones = {
        codsede: '',
        codCarrera: '',
        nombreCarrera: '',
        numeroAlumno: '',
        codVia: 0,
        tipo: '',
        alumnoNuevo: '',
        matriculado: 0,
        estadoAcademico: '',
        matriculaEnLinea: 0,
        ano: 0,
        periodo: 0,
        codPlanificacionAcademica: 0,
        codPlanEstudio: '',
        fechaInicio: '',
        negocio: '',
        codigoNegocio: 0,
        mensaje: '',
        accesoInicio: '',
        accesoFin: '',
        idPeriodo: 0,
        idPersona: 0
    }; //IViewPostulaciones
    const [listaPostulaciones, setListaPostulaciones] = useState(lista);

    const [listoPostulacion, setListoPostulacion] = useState(false);
    // const deudaFinancieraL: IViewDeudaFinanciera = {
    //     autorizadoMatricula: false,
    //     autorizadoTomaRamo: false,
    //     rutCliente: 0,
    //     tieneDeuda: false,
    // };
    // const [deudaFinanciera, setDeudaFinanciera] = useState(deudaFinancieraL);
    const [debeFirmar, setDebeFirmar] = useState(false);
    // const [errorDeuda, setErrorDeuda] = useState(true)
    const [errorCarr, setErrorCarr] = useState(true);
    const [errorEtapa, setErrorEtapa] = useState(true);
    const [listo, setListo] = useState(false);
    const [token, setToken] = useState('');
    const listaRF: Array<IViewTipoPersona> = [
        {
            idPersona: 0,
            run: 0,
            dv: '',
            nombres: '',
            primerApellido: '',
            segundoApellido: '',
            fechaNacimiento: '',
            codigoComuna: 0,
            nombreComuna: '',
            direccion: '',
            telefono: 0,
            email: '',
            codSexo: 0,
            sexo: '',
            idPais: 0,
            pais: '',
            idNacionalidad: 0,
            nacionalidad: '',
            runFormato: '',
            nombreCompleto: '',
        },
    ];

    const [representanteFinanciero, setRepresentanteFinanciero] = useState(listaRF);
    const [errorToken, setErrorToken] = useState(false)
    const [codNegocioo, setCodigoNegocioo] = useState(0)
    function calcularDVRUT(rut: any) {
        // Eliminar puntos y guiones
        rut = rut.replace(/\D/g, "");

        // Verificar que sea un RUT válido (sin incluir el DV)
        if (!/^\d+$/.test(rut) || rut.length < 1) {
            throw new Error("El RUT debe ser un número válido.");
        }

        let suma = 0;
        let factor = 2;

        // Recorrer los dígitos de derecha a izquierda
        for (let i = rut.length - 1; i >= 0; i--) {
            suma += parseInt(rut[i]) * factor;
            factor = factor === 7 ? 2 : factor + 1;
        }

        const resto = suma % 11;
        let dv;

        if (resto === 1) {
            dv = "K";
        } else if (resto === 0) {
            dv = "0";
        } else {
            dv = (11 - resto).toString();
        }

        return rut + "-" + dv;
    }
    useEffect(() => {
        let url = window.location.href;
        if (url.indexOf('?') !== -1) {
            var alumno = queryString.parse(window.location.search);
            let codNegocio = alumno.lineaestudio!.toString() === 'DEC' ? 3 : 2;
            let idPeriodo = alumno.idPeriodo !== null && alumno.idPeriodo !== undefined ? alumno.idPeriodo : 0;
            let pasaporte = alumno.pasaporte !== null && alumno.pasaporte !== undefined ? alumno.pasaporte : "";
            let rut = alumno.rut !== null && alumno.rut !== undefined && alumno.rut.length > 0 ? alumno.rut : 0;
            let codplanifica = alumno.codplanifica !== null && alumno.codplanifica !== undefined ? alumno.codplanifica : 0;
            let curso = alumno.curso !== null && alumno.curso !== undefined ? alumno.curso : "";
            let data = {
                "rut": rut,
                "pasaporte": pasaporte,
                "idPeriodo": idPeriodo || 0,
                "anoProceso": 0,
                "periodoProceso": 0,
                "codNegocio": codNegocio,
                "codPrograma": curso,
                "codPlanificacion": codplanifica
            }
            /* setRut(Number(alumno.rut)); */
            setCodigoNegocioo(codNegocio)
            ObtenerTokenPostDecLogic(SelObtenerToken, data)

        } else {
            setTimeout(() => {
                setValidando1(false);
            }, 5000);
            setUrlBad(true);
        }
    }, []);
    const SelObtenerToken = (error: Boolean, err: string, data: any) => {
        try {
            if (error === false && data != null && data.token != "") {
                setToken(data.token)
                setRut(data.rut)
            } else {
                setErrorToken(true)
                setErrorCarr(true)
            }
        } catch (err) {
            console.log('error', err)
        }
    }

    useEffect(() => {
        let url = window.location.href;
        if (url.indexOf('?') !== -1 && token != "" && rut > 0) {
            var alumno = queryString.parse(window.location.search);
            /* if (alumno.pasaporte !== '' && (alumno.rut !== '' && alumno.rut !== '0' && alumno.rut !== null) && alumno.pasaporte !== undefined) { */
            let codNegocio = alumno.lineaestudio!.toString() === 'DEC' ? 3 : 2;
            setUrlBad(true);
            /* if (alumno.rut !== '' && alumno.rut !== '0' && alumno.rut !== null) {
                setRut(Number(alumno.rut));
            } */
            let codPlanifA =
                parseInt(alumno.codplanifica!.toString()) === undefined
                    ? 0
                    : parseInt(alumno.codplanifica!.toString());

            let idPeriodo = alumno.idPeriodo !== null || alumno.idPeriodo !== undefined ? alumno.idPeriodo : 0;
            let headers = {
                rut: calcularDVRUT(rut.toString()),
                token: token,
                codNegocio: codNegocio
            }
            ObtienePostulacionesPostExtLogic(
                selListaPostulaciones,
                headers,
                rut,
                alumno?.pasaporte?.toString() || "",
                0,
                0,
                codNegocio,
                alumno.curso!.toString(),
                codPlanifA,
                Number(idPeriodo),
            );

            //if (codNegocio === 2 || codNegocio === 3) {
            ObtieneTieneFirmaContratoLogic(
                selListaFirma,
                codNegocio,
                rut,
                alumno.curso!.toString(),
                0,
                0,
                codPlanifA,
            );
            //}

            setTimeout(() => {
                setValidando1(false);
            }, 5000);
            /* } */
        } else {
            setTimeout(() => {
                setValidando1(false);
            }, 5000);
            setUrlBad(true);
        }
    }, [token, rut]);

    const selRut = (error: Boolean, err: string, Estudiante: any) => {
        try {
            if (error === false && Estudiante[0].run.toString().trim().length > 1) {
                setRut(Estudiante[0].run);
            } else {
                if (err != "500") {
                    setOpenModalToken({ open: true, mnsj: err })
                }
            }
        } catch (error) {
            console.log('error', error);
        }
    };

    const selListaFirma = (error: Boolean, err: string, data: any) => {
        if (error === false && data !== undefined) {
            setDebeFirmar(data);
        } else {
            setDebeFirmar(false);
            console.log('Error');
        }
    };

    const selPrimeraEtapa = (error: Boolean, err: string, data: any) => {
        setTimeout(() => {
            setValidando2(false);
        }, 5000);
        if (error === false && data !== undefined) {
            setIdProceso(data);
            setErrorEtapa(false);
        } else {
            setErrorEtapa(true);
            setTimeout(() => {
                setValidando2(false);
            }, 5000);
        }
    };

    useEffect(() => {
        if (!errorCarr && !errorEtapa) {
            /* if (listoPostulacion) { */
            if (listaPostulaciones.mensaje === '' || listaPostulaciones.mensaje === null) {
                if (idProceso > 0) {
                    setListo(true);
                }
            }
            /* } */
        }
    }, [errorCarr, errorEtapa, /* listoPostulacion, */ idProceso]);

    useEffect(() => {
        if (listo) {
            var alumno = queryString.parse(window.location.search);
            setTimeout(() => {
                history.push({
                    pathname: '/matricula',
                    state: {
                        rut: rut,
                        codigoNegocio: listaPostulaciones.codigoNegocio,
                        codCarrera: listaPostulaciones.codCarrera,
                        codigoPlanificacionAcademica: listaPostulaciones.codPlanificacionAcademica,
                        codsede: listaPostulaciones.codsede,
                        nombreAlumno: nombreAlumno,
                        nombreCarrera: listaPostulaciones.nombreCarrera,
                        numeroAlumno: listaPostulaciones.numeroAlumno,
                        anioPromocion: listaPostulaciones.ano,
                        periodoPromocion: listaPostulaciones.periodo,
                        idProceso: idProceso,
                        menu: listaPostulaciones.codigoNegocio === 2 ? '1' : '3',
                        codComercio: codComercio,
                        rutRF: representanteFinanciero.length > 0 ? representanteFinanciero[0].run : 0,
                        debeFirmar: debeFirmar,
                        idPeriodo: listaPostulaciones.idPeriodo,
                        idPersona: listaPostulaciones.idPersona,
                        pasaporte: alumno.pasaporte,
                        headers: {
                            token: token,
                            rut: calcularDVRUT(rut.toString()),/* rutPostulante */
                            codNegocio: listaPostulaciones.codigoNegocio
                        }
                    },
                });
            }, 2000);
        }
    }, [listo]);

    const selListaPostulaciones = (error: Boolean, err: string, Postulaciones: IViewPostulaciones) => {
        if (error === false && Postulaciones !== undefined) {
            sessionStorage.setItem('codCarrera', JSON.stringify(Postulaciones.codCarrera));
            sessionStorage.setItem('nombreCarrera', JSON.stringify(Postulaciones.nombreCarrera));
            sessionStorage.setItem('codsede', JSON.stringify(Postulaciones.codsede));
            sessionStorage.setItem('idPeriodo', JSON.stringify(Number(Postulaciones.idPeriodo)));
            sessionStorage.setItem('fase', JSON.stringify('instrucciones'));


            var alumno = queryString.parse(window.location.search);
            //console.log(alumno);

            setListaPostulaciones(Postulaciones);
            let codNegocio = alumno.lineaestudio!.toString() === 'DEC' ? 3 : 2;
            //let codPlanifA = parseInt(alumno.codplanifica!.toString()) === undefined ? 0 : parseInt(alumno.codplanifica!.toString());
            let idPeriodo = alumno.idPeriodo !== null && alumno.idPeriodo !== undefined ? alumno.idPeriodo
                : (Postulaciones.idPeriodo !== null && Postulaciones.idPeriodo !== undefined ? Postulaciones.idPeriodo : 0);

            let headers = {
                rut: calcularDVRUT(rut.toString()),
                token: token,
                codNegocio: codNegocio
            }

            if (alumno.pasaporte !== '' && alumno.pasaporte !== undefined) {
                ObtieneDatosPersonalesLogic(
                    selListaPostulante,
                    headers,
                    0,
                    alumno!.pasaporte !== null ? alumno.pasaporte.toString() : '',
                    Postulaciones.codigoNegocio,
                    1,
                    Number(idPeriodo),
                    Postulaciones,
                );
            }
            else if (
                Postulaciones.codCarrera !== '' &&
                Postulaciones.codCarrera !== undefined &&
                Postulaciones.codCarrera !== null
            ) {
                ObtieneDatosPersonalesLogic(
                    selListaPostulante,
                    headers,
                    alumno.rut !== '' ? Number(alumno.rut) : rut,
                    '',
                    Postulaciones.codigoNegocio,
                    1,
                    Number(idPeriodo),
                    Postulaciones,
                );
            }

            setErrorCarr(false);
            setTimeout(() => {
                setValidando3(false);
            }, 5000);

            if (
                Postulaciones.codCarrera !== '' &&
                Postulaciones.codCarrera !== undefined &&
                Postulaciones.codCarrera !== null
            ) {
                InsertPrimeraEtapaProcesoLogic(
                    selPrimeraEtapa,
                    alumno.rut !== '' ? Number(alumno.rut) : rut,
                    0,
                    0,
                    Postulaciones.codigoNegocio,
                    Postulaciones.codCarrera,
                    Postulaciones.codPlanificacionAcademica,
                    Number(idPeriodo)
                );
            }
        } else {
            if (err != "500") {
                setOpenModalToken({ open: true, mnsj: err })
            } else {
                setErrorCarr(true);
                setTimeout(() => {
                    setValidando3(false);
                }, 5000);
            }
        }
    };

    const selListaPostulante = (error: Boolean, err: string, Estudiante: any, Postulaciones: any) => {
        try {
            if (error === false && Estudiante[0].run.toString().trim().length > 1) {
                var alumno = queryString.parse(window.location.search);
                let codNegocio = alumno.lineaestudio!.toString() === 'DEC' ? 3 : 2;
                sessionStorage.setItem('nombreCompleto', JSON.stringify(Estudiante[0].nombreCompleto));
                setNombreAlumno(Estudiante[0].nombreCompleto);

                setListaPostulaciones(Postulaciones);
                let headers = {
                    rut: calcularDVRUT(rut.toString()),
                    token: token,
                    codNegocio: codNegocio
                }
                GrabarDatosPersonalesLogic(
                    selResultadoParametros,
                    headers,
                    0,
                    Estudiante[0].runFormato.trim(),
                    Estudiante[0].pasaporte.trim(),
                    Estudiante[0].nombres.trim(),
                    Estudiante[0].primerApellido.trim(),
                    Estudiante[0].segundoApellido.trim(),
                    new Date(Estudiante[0].fechaNacimiento),
                    Estudiante[0].codigoComuna,
                    Estudiante[0].nombreComuna.trim(),
                    Estudiante[0].direccion.trim(),
                    Estudiante[0].telefono,
                    Estudiante[0].email.trim(),
                    Estudiante[0].codSexo,
                    Estudiante[0].sexo.trim(),
                    Estudiante[0].idPais,
                    Estudiante[0].pais.trim(),
                    Estudiante[0].idNacionalidad,
                    Estudiante[0].nacionalidad,
                    Estudiante[0].run,
                    Postulaciones.codigoNegocio,
                    Postulaciones.codCarrera,
                    Postulaciones.ano,
                    Postulaciones.periodo,
                    Postulaciones.codPlanificacionAcademica,
                    1,
                    Postulaciones,
                );
            } else {
                if (err != "500") {
                    setOpenModalToken({ open: true, mnsj: err })
                }
            }
        } catch (error) {
            console.log('error', error);
        }
    };

    const selResultadoParametros = (error: Boolean, err: string, Resultado: any, Postulaciones: any) => {
        try {
            let _tt = JSON.stringify(location.state);
            let _params = JSON.parse(_tt);
            if (error === false && Resultado !== undefined) {

                var alumno = queryString.parse(window.location.search);
                let codNegocio = alumno.lineaestudio!.toString() === 'DEC' ? 3 : 2;


                if (codNegocio === 2) {
                    ObtieneDatosTipoPersonaPorPostulacionLogic(
                        selListaRepresentanteFinanciero,
                        _params.headers,
                        alumno.rut !== '' ? Number(alumno.rut) : rut,
                        codNegocio,
                        Postulaciones.codCarrera,
                        Postulaciones.ano,
                        Postulaciones.periodo,
                        Postulaciones.codPlanificacionAcademica,
                        2,
                        Postulaciones.idPeriodo
                    );
                }

                if (codNegocio === 3) {
                    setListoPostulacion(true);
                }
            } else {
                if (err != "500") {
                    setOpenModalToken({ open: true, mnsj: err })
                }
            }
        } catch (err) {
            console.log('error', err);
        }
    };

    const selListaRepresentanteFinanciero = (error: Boolean, err: string, list: Array<IViewTipoPersona>) => {
        try {
            if (error === false && list.length > 0) {
                let _tt = JSON.stringify(location.state);
                let _params = JSON.parse(_tt);
                /* console.log(list) */
                setRepresentanteFinanciero(list);
                //TODO: GUARDAR RF

                var alumno = queryString.parse(window.location.search);
                let codNegocio = alumno.lineaestudio!.toString() === 'DEC' ? 3 : 2;

                GrabarDatosPersonalesLogic(
                    selResultadoRepresentanteFinancieroParametros,
                    _params.headers,
                    0,
                    list[0].runFormato.trim(),
                    '',
                    list[0].nombres.trim(),
                    list[0].primerApellido.trim(),
                    list[0].segundoApellido.trim(),
                    new Date(list[0].fechaNacimiento),
                    list[0].codigoComuna,
                    list[0].nombreComuna.trim(),
                    list[0].direccion.trim(),
                    list[0].telefono,
                    list[0].email.trim(),
                    list[0].codSexo,
                    list[0].sexo.trim(),
                    list[0].idPais,
                    list[0].pais.trim(),
                    list[0].idNacionalidad,
                    list[0].nacionalidad,
                    alumno.rut !== '' ? Number(alumno.rut) : rut,
                    codNegocio,
                    listaPostulaciones.codCarrera,
                    listaPostulaciones.ano,
                    listaPostulaciones.periodo,
                    listaPostulaciones.codPlanificacionAcademica,
                    2,
                );
            } else {
                if (err != "500") {
                    setOpenModalToken({ open: true, mnsj: err })
                }
            }
        } catch (er) {
            console.log('error', er);
        }
    };

    const selResultadoRepresentanteFinancieroParametros = (error: Boolean, err: string, Resultado: any) => {
        try {
            if (error === false && Resultado !== undefined) {
                setListoPostulacion(true);
            } else {
                if (err != "500") {
                    setOpenModalToken({ open: true, mnsj: err })
                }
            }
        } catch (err) {
            console.log('error', err);
        }
    };

    useEffect(() => {
        let text = '';
        if (menu === '1') text = 'Datos personales';
        else if (menu === '3') text = 'Selección de forma de pago';
        else if (menu === '3') text = 'Pago';
        else if (menu === '4') text = 'Carga de documentos';
        else if (menu === '5') text = 'Firma de Contrato';
        else if (menu === '6') text = 'Generar Matrícula';

        setTextMenuResponsive(text);
    }, [menu]);

    const handlecambioMenu = (cambio: string) => {
        scroll.scrollToTop();
        setMenu(cambio);
    };

    const handleFormaPago = (forma: any) => {
        setFormaPago(forma);
    };

    return (
        <>
            <NewHeaderInicio />
            {
                errorToken ?
                    <div className="site-main__container">
                        <div style={{ textAlign: 'center', marginTop: 100 }}>
                            <ErrorOutlineRounded style={{ fontSize: 50, color: 'red' }} />
                            <br />
                            <a>
                                <span>
                                    No se pudo validar su identidad, favor comunicarse con la universidad.
                                </span>
                            </a>
                            <br />
                        </div>
                    </div>
                    :
                    validando1 && validando2 && validando3 ? (
                        <div className="site-main__container">
                            <div style={{ textAlign: 'center', marginTop: 100 }}>
                                <CircularProgress disableShrink />
                                <br />
                                <a>
                                    <span>Validando información.</span>
                                </a>
                            </div>
                        </div>
                    ) : !errorCarr && !errorEtapa ? (
                        listaPostulaciones.mensaje === '' || listaPostulaciones.mensaje === null ? (
                            ''
                        ) : (
                            <div className="site-main__container">
                                <div style={{ textAlign: 'center', marginTop: 100 }}>
                                    <ErrorOutlineRounded style={{ fontSize: 50, color: 'red' }} />
                                    <br />
                                    <a>
                                        {parse(listaPostulaciones.mensaje)}
                                        {/* <span>{listaPostulaciones.mensaje}</span> */}
                                    </a>
                                    <br />
                                </div>
                            </div>
                        )
                    ) : (
                        <div className="site-main__container">
                            <div style={{ textAlign: 'center', marginTop: 100 }}>
                                <ErrorOutlineRounded style={{ fontSize: 50, color: 'red' }} />
                                <br />
                                <a>
                                    <span>
                                        Usted no está autorizado para matricularse, favor comunicarse con la universidad.
                                    </span>
                                </a>
                                <br />
                            </div>
                        </div>
                    )}
            {
                openModalToken.open ?
                    <MensajeToken mnsj={openModalToken.mnsj} codNegocio={1}></MensajeToken>
                    :
                    ""
            }
        </>
    );
};

export default InicioPostExt;
